/* Ganbare Kickers — Homepage JS */
(function () {
  'use strict';

  /* ── Reveal on scroll ────────────────────────────────────── */
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('gb-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('[data-reveal]').forEach((el) => {
    const r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) {
      // already in viewport on load — reveal immediately, no scroll needed
      el.style.transition = 'none';
      el.classList.add('gb-visible');
      requestAnimationFrame(() => { el.style.transition = ''; });
    } else {
      io.observe(el);
    }
  });

  /* ── Parallax ────────────────────────────────────────────── */
  const parallaxEls = [...document.querySelectorAll('[data-parallax]')];
  if (parallaxEls.length) {
    const mqParallax = window.matchMedia('(min-width: 750px)');
    const onScroll = () => {
      if (!mqParallax.matches) {
        parallaxEls.forEach((el) => { el.style.transform = ''; });
        return;
      }
      const vh = window.innerHeight;
      parallaxEls.forEach((el) => {
        const r   = el.getBoundingClientRect();
        const spd = parseFloat(el.getAttribute('data-parallax')) || 0.1;
        const off = (r.top + r.height / 2 - vh / 2) * -spd;
        el.style.transform = `translate3d(0,${off.toFixed(1)}px,0)`;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Product-card hover ───────────────────────────────────── */
  document.querySelectorAll('[data-gb-card]').forEach((card) => {
    const off   = parseFloat(card.getAttribute('data-offset')) || 0;
    const img   = card.querySelector('[data-gb-img]');
    const cta   = card.querySelector('[data-gb-cta]');
    const title = card.querySelector('[data-gb-title]');
    const badge = card.querySelector('[data-gb-badge]');
    if (off) card.style.transform = `translateY(${off}px)`;
    card.addEventListener('mouseenter', () => {
      if (img)   { img.style.transform = 'scale(1.08)'; img.style.opacity = '1'; }
      if (cta)   cta.style.transform = 'translateY(0)';
      if (title) title.style.color = '#FF2D1F';
      if (badge) badge.style.transform = 'scale(1.14) rotate(-5deg)';
    });
    card.addEventListener('mouseleave', () => {
      if (img)   { img.style.transform = 'scale(1)'; img.style.opacity = '0.85'; }
      if (cta)   cta.style.transform = 'translateY(110%)';
      if (title) title.style.color = '#F5F3EF';
      if (badge) badge.style.transform = 'none';
    });
  });

  /* ── Custom cursor ──────────────────────────────────────── */
  const cursor = document.querySelector('[data-gb-cursor]');
  if (cursor) {
    let cx = -20, cy = -20, tx = -20, ty = -20, active = false, half = 7;
    window.addEventListener('mousemove', (e) => {
      tx = e.clientX; ty = e.clientY;
      if (!active) { cx = tx; cy = ty; active = true; }
    });
    const loop = () => {
      if (active) {
        cx += (tx - cx) * 0.18;
        cy += (ty - cy) * 0.18;
        cursor.style.left = `${(cx - half).toFixed(1)}px`;
        cursor.style.top  = `${(cy - half).toFixed(1)}px`;
      }
      requestAnimationFrame(loop);
    };
    loop();
    document.addEventListener('mouseover', (e) => {
      if (e.target.closest('a, button, [data-magnet]')) {
        half = 26;
        cursor.style.width = '52px'; cursor.style.height = '52px';
        cursor.style.background = 'rgba(255,45,31,0.18)';
      }
    });
    document.addEventListener('mouseout', (e) => {
      if (e.target.closest('a, button, [data-magnet]')) {
        half = 7;
        cursor.style.width = '14px'; cursor.style.height = '14px';
        cursor.style.background = '';
      }
    });
  }

  /* ── Live clock (Berlin) ─────────────────────────────────── */
  const clockEl = document.querySelector('[data-gb-clock]');
  if (clockEl) {
    const tick = () => {
      const t = new Date().toLocaleTimeString('en-GB', {
        hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Berlin'
      });
      clockEl.textContent = '[ BERLIN ' + t + ' ]';
    };
    tick();
    setInterval(tick, 30000);
  }
})();
